import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DownloadLiner18 = () => /*#__PURE__*/_jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    d: "M10.9597 5.93359C13.3597 6.14026 14.3397 7.37359 14.3397 10.0736V10.1603C14.3397 13.1403 13.1464 14.3336 10.1664 14.3336H5.82641C2.84641 14.3336 1.65308 13.1403 1.65308 10.1603V10.0736C1.65308 7.39359 2.61974 6.16026 4.97974 5.94026",
    stroke: "currentColor",
    strokeWidth: "1.33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8 1.3335V9.92016",
    stroke: "currentColor",
    strokeWidth: "1.33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsx("path", {
    d: "M10.233 8.43359L7.99969 10.6669L5.76636 8.43359",
    stroke: "currentColor",
    strokeWidth: "1.33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});